export default __webpack_public_path__ + "static/media/residencial_5.ea384df8.png";